'use strict';



const $ = require('jquery');
const openClassName = 'is-active';
const clickMaskParentClassName = 'js-click-mask-parent';
const clickMaskParentActiveClassName = 'c-click-mask-parent--active';
const clickMaskClassName = 'js-nav-click-mask';
const clickMaskActiveClassName = 'c-click-mask--active';
const active = $nav => $nav.hasClass(openClassName);
const toggleClassName = 'js-nav-toggle';
const navClassName = 'js-nav';
const $body = $('body');



module.exports = function toggleNav() {

	$(`.${navClassName}`).each(function() {

		const $nav = $(this);
		const id = $nav.attr('id');
		const navToggleClassName = `.${toggleClassName}[data-target=${id}]`;
		const $clickMask = appendClickMask($nav);

		$body.on('click', navToggleClassName, e => {
			e.preventDefault();
			e.stopPropagation();
			toggle($nav);
		});

		$clickMask.on('click', () => close($nav));

	});

};



function toggle($nav) {
	return active($nav)
		? close($nav)
		: open($nav);
}



function close($nav) {
	$nav.removeClass(openClassName);
	blurClickMask($nav);
}



function open($nav) {
	$nav.addClass(openClassName);
	focusClickMask($nav);
}



function appendClickMask($nav) {
	const $parent = $nav.closest(`.${clickMaskParentClassName}`);
	let $clickMask

	if($clickMask = $parent.data('clickMask')) {
		return $clickMask;
	}

	$clickMask = $(`<div class='${clickMaskClassName}  c-click-mask'>`).prependTo($parent);
	$parent.data('clickMask', $clickMask);
	return $clickMask;
}



function getClickMask($nav) {
	return $nav
		.closest(`.${clickMaskParentClassName}`)
		.data('clickMask');
}



function getClickMaskParent($nav) {
	return $nav
		.closest(`.${clickMaskParentClassName}`);
}



function removeClickMask() {
	if($clickMask) {
		$clickMask.remove();
		$clickMask = null;
	}
}



function focusClickMask($nav) {
	updateClickMask($nav, 'addClass');
}



function blurClickMask($nav) {
	updateClickMask($nav, 'removeClass');
}


function updateClickMask($nav, method) {
	getClickMaskParent($nav)
		[method](clickMaskParentActiveClassName);

	getClickMask($nav)
		[method](clickMaskActiveClassName);
}
